/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable */
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import DevTools from '../../components/DevTools';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Full from '../Full';
import LoginContainer from '../../containers/Authentication/LoginContainer';
import RegisterContainer from '../../containers/Register/RegisterContainer';
import RegisterGuestContainer from '../../containers/Register/RegisterGuestContainer';

import RequestResetPasswordContainer from '../../containers/ResetPassword/RequestResetPasswordContainer';
import ConfirmRegistrationContainer from '../Register/ConfirmRegistrationContainer';
import ResetPasswordContainer from '../../containers/ResetPassword/ResetPasswordContainer';

import { style } from "react-toastify";
style({
  width: "320px",
  colorDefault: "#02426",
  colorInfo: "#3498db",
  colorSuccess: "#65BE60",
  colorWarning: "#FFA500",
  colorError: "#ff5454"
});

const history = createHistory();

let renderDevTools = !(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test');
if (process.env.REACT_APP_CYPRESS === 'true') {
  renderDevTools = false;
}

export default class Root extends React.Component {

  render() {
    const { store } = this.props;
    let devTools = renderDevTools ? <DevTools /> : null;
    return (
      <Provider store={store}>
        <div> 
          <ConnectedRouter history={history}>
            <Switch>              
              <Route exact path='/login' name="Login Page" component={LoginContainer} />
              <Route exact path='/reset' component={RequestResetPasswordContainer} />
              <Route exact path='/reset/:token' component={ResetPasswordContainer} />
              <Route exact path='/register' name="Register Page" component={RegisterContainer} />
              <Route exact path='/register/confirm/:token' name="Register Page" component={ConfirmRegistrationContainer} />
              <Route exact path='/guest' name="Register Guest" component={RegisterGuestContainer}/>
              <Route path="/dashboard" name="Dashboard" component={Full} />      
              <Redirect from="/" to="/dashboard" />
            </Switch>
          </ConnectedRouter>
          {devTools}
        </div>
      </Provider >
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/containers/Root/Root.js